import { useState, useEffect, useMemo, useRef } from 'react';
import _ from 'underscore';
import services from '../../../services/services.js'
import { Urls } from '../../../services/Urls.js'
import { callautopopulate } from '../../../services/callautopop.js'
import { useContext } from 'react';
import { ToastContext } from '../../../context/ToastContext.js';
import { dateConvert, timeStringToDate } from '../../../utils/Helper.js';

export const useCalendar = () => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [loader, setloader] = useState(false)
    const tagRef = useRef(null);
    const gridRef = useRef();
    const [updateHolidayPopup, setUpdateHolidayPopup] = useState(false)
    const row = useRef([])
    const [rowData, setRowData] = useState([])
    const [holidayType, setHolidayType] = useState('');
    const [dayTypeOption, setDayTypeOption] = useState([]);
    const [visible, setVisible] = useState(false);
    const [groupOption, setGroupOption] = useState([])
    const [filterValues, setFilterValues] = useState({})
    const [updatedData, setUpdatedData] = useState({});
    const [previousData, setPreviousData] = useState({});
    const [selectView, setSelectView] = useState("week");
    const [edit, setEdit] = useState(false);
    const [editData, setEditData] = useState({ date: [], hours: "", shift_start: "", shift_end: "" });
    const [showCalendarConfig, setShowCalendarConfig] = useState(false);
    const [showGenerateCalendar, setShowGenerateCalendar] = useState({ visible: false, unit: {}, year: 0, config: {}, config_opts: [], shift_start: "", shift_end: "" });

    useEffect(() => {
        sessionStorage.removeItem("day_calendar_config");
        callautopopulate("day_types", "day_calendar_groups", "day_calendar_config").then(res => {
            setGroupOption(res?.day_calendar_groups)
            setDayTypeOption(res?.day_types)
            const group = res?.day_calendar_groups?.length === 1 ? res?.day_calendar_groups[0] : null
            setFilterValues({
                year: new Date().getFullYear(),
                day_calendar_groups: group
            })
            setRowData([]);
            group && getHolidayCalender(new Date().getFullYear(), group);
            setShowGenerateCalendar((prev) => ({ ...prev, config_opts: _.sortBy(_.uniq(res?.day_calendar_config, "configuration_id"), "configuration_name") }));
        });
    }, [])
  
    
    useEffect(() => {
        const group = filterValues?.day_calendar_groups;

        if (filterValues?.year && group?.group_id) {
            getHolidayCalender(filterValues?.year, group);
        }
    }, [filterValues?.year, filterValues?.day_calendar_groups]);


    const getHolidayCalender = async (year, group) => {
        setRowData([])
        const payload = {
            year: year || filterValues?.year,
            group_id: group?.group_id || filterValues?.day_calendar_groups?.group_id
        }
        try {
            setloader(true)
            const res = await services.getInvokeRemote('POST', Urls('GETHOLIDAYCALENDARLIST'), payload)
            const data = res.body.data.holiday_Calendar;
            if (data) {
                setRowData(data)
                row.current = data
                setloader(false)
                if (year && group) {
                    setFilterValues({ year: year, day_calendar_groups: group })
                }
            }

        } catch (error) {
            console.error('Error :', error);
        }
    };

    // this function call the holiday update 
    const upsertHolidayCalender = async () => {
        if (_.isEqual(updatedData, previousData)) {
            showInfo("info", "No changes made");
            return;
        }
        if (!updatedData?.day_date) {
            showInfo("info", "Please select Date.");
            return;
        }
        if (!updatedData?.description) {
            showInfo("info", "Please enter name.");
            return;
        }
        if (!updatedData?.day_type_id) {
            showInfo("info", "Please select Day type.");
            return;
        }
        const payload = {
            day_id: updatedData?.day_id || 0,
            day_date: dateConvert(updatedData?.day_date, 'iso-string'),
            description: updatedData?.description,
            is_active: updatedData?.is_active,
            day_type_id: updatedData?.day_type_id?.day_type_id,
            day_hours: parseFloat(updatedData?.day_hours || 0) || 0,
            group_id: filterValues?.day_calendar_groups?.group_id || 0,
            shift_start_time: dateConvert(updatedData?.shift_start, "iso-string") || "",
            shift_end_time: dateConvert(updatedData?.shift_end, "iso-string") || "",
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('UPSERTHOLIDAYCALENDAR'), payload)
            if (res?.status === 200) {
                showSuccess('Success', res.body.message)
                getHolidayCalender()
                setUpdateHolidayPopup(false);
            } else {
                showError("Error", res.body.errorMessage);
            }

        } catch (error) {
            console.error('Error :', error);
        }
    };

    const handleDelete = async (rowdata) => {
        const payload = {
            day_id: rowdata.data.day_id
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('DELETEHOLIDAYCALENDARREMOVE'), payload)
            if (res.body.data) {
                setVisible(false)
                showSuccess("Info", res.body.message)
                let gridData = [...row.current];
                gridData.splice([rowdata.node.rowIndex], 1);
                gridRef.current.api.applyTransaction({ remove: [rowdata.data] });
            }
        } catch (error) {
            setVisible(false)
            console.error('Error :', error);
        }
    }

    // this function use for handle the dates
    const dateTemplate = (date) => {
        const dayData = rowData?.find((day) => {
            const dayDate = new Date(day.day_date);
            return (
                dayDate.getFullYear() === date.year &&
                dayDate.getMonth() === date.month &&
                dayDate.getDate() === date.day
            );
        });
        if (dayData && dayData.day_type_key === 'weekly_off') {
            return (
                <div className='hd-date-container'>
                    <div className='hd-dates' style={{ backgroundColor: dayData?.day_type_color ? dayData?.day_type_color : "#f2f2f2" }}>
                        <strong>{date.day}</strong>
                    </div>
                </div>
            );
        }
        if (dayData && dayData.day_type_key === 'holiday') {
            return (
                <div className='hd-date-container'>
                    <div className='hd-dates' style={{ backgroundColor: dayData?.day_type_color || "transparent" }}>
                        <strong>{date.day}</strong>
                    </div>
                </div>
            );
        }
        return (
            <div className='hd-date-container'>
                <div className='hd-dates' style={{ backgroundColor: dayData?.day_type_color || "transparent" }}>
                    <strong>{date.day}</strong>
                </div>
            </div>
        );
    };

    const handleChange = (e, check, key) => {
        if (key === "shift_start" || key === "shift_end") {
            setUpdatedData((prev) => ({ ...prev, [key]: e }));
        } else if (check) {
            setUpdatedData((prev) => ({ ...prev, [e?.target?.name]: e?.target?.checked }))
        } else {
            setUpdatedData((prev) => ({ ...prev, [e?.target?.name]: e?.target?.value }))
        }

    }

    // this function handle the slected date updated data object for prefill
    const handleSelctedDate = (e, check) => {
        if (check) {
            setUpdateHolidayPopup(true)
            const data = {
                day_id: e?.day_id,
                day_date: new Date(e?.day_date),
                description: e?.descriptions,
                is_active: e?.is_active,
                day_type_id: _.find(dayTypeOption, (item) => item?.day_type_id === e?.day_type_id),
                day_hours: e?.day_hours,
                shift_start: timeStringToDate(e?.shift_start_time),
                shift_end: timeStringToDate(e?.shift_end_time)
            }
            setUpdatedData(data)
            setPreviousData({ ...data });
        } else {
            const selectedDate = new Date(Date.UTC(e?.value?.getFullYear(), e?.value?.getMonth(), e?.value?.getDate()));
            const selectedDateISO = selectedDate?.toISOString()?.split('T')[0];
            const matchingDay = rowData?.find((day) => {
                const dayDateISO = day.day_date.split('T')[0];
                return dayDateISO === selectedDateISO;
            });
            setUpdateHolidayPopup(true)
            const data = {
                day_id: matchingDay?.day_id,
                day_date: new Date(matchingDay?.day_date),
                description: matchingDay?.descriptions,
                is_active: matchingDay?.is_active,
                day_type_id: _.find(dayTypeOption, (item) => item?.day_type_id === matchingDay?.day_type_id),
                day_hours: matchingDay?.day_hours,
                shift_start: timeStringToDate(matchingDay?.shift_start_time),
                shift_end: timeStringToDate(matchingDay?.shift_end_time)
            }
            setUpdatedData(data)
            setPreviousData({ ...data });
        }

    }


    const monthData = useMemo(() => {
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        return months.map(month => {
            const monthObj = { month };
            for (let day = 1; day <= 31; day++) {
                monthObj[day] = null;
            }
            return monthObj;
        });
    }, []);

    // Map rowData to month structure
    const mappedData = useMemo(() => {
        const data = JSON.parse(JSON.stringify(monthData));

        rowData.forEach(day => {
            const date = new Date(day.day_date);
            const month = date.getMonth();
            const dayOfMonth = date.getDate();

            if (data[month] && dayOfMonth <= 31) {
                data[month][dayOfMonth] = day;
            }
        });

        return data;
    }, [rowData, monthData]);

    // Generate column definitions
    const columnDefs = useMemo(() => {
        const columns = [{
            headerName: 'Month',
            field: 'month',
            pinned: 'left',
            width: 120
        }];

        for (let day = 1; day <= 31; day++) {
            columns.push({
                headerName: day.toString(),
                field: day.toString(),
                width: 40,
                cellRenderer: (params) => {
                    if (!params.value) return '-';
                    return <div onClick={() => handleSelctedDate(params.value, true)}>{params?.value?.day_hours}</div>;
                },
                cellStyle: (params) => {
                    if (!params.value) return {};
                    return {
                        textAlign: "center", fontWeight: "500",
                        backgroundColor: params.value.day_type_color ? params.value.day_type_color
                            : params.value?.day_type_key === "weekly_off" ? "#e9f4fc" : "" || 'transparent'
                    };
                }
            });
        }

        return columns;
    }, [dayTypeOption]);

    const handleUpsertCalendarHours = async () => {
        try {
            if (!filterValues?.day_calendar_groups?.group_id) {
                showInfo("Info", "Please select a unit");
                return;
            } else if (_.isEmpty(editData?.date) || !editData?.date || !editData?.date?.[0] || !editData?.date?.[1]) {
                showInfo("Info", "Please select date range");
                return;
            } else if (!editData?.hours && !editData?.shift_start && !editData?.shift_end) {
                showInfo("Info", "Please enter the day hours");
                return;
            } else if (!editData?.hours && ((editData?.shift_start && !editData?.shift_end) || (!editData?.shift_start && editData?.shift_end))) {
                showInfo("Info", "Please select shift start and end both");
                return;
            } else {
                const payload = {
                    "from_date": dateConvert(editData?.date?.[0]?.toDate(), "iso-string"),
                    "to_date": dateConvert(editData?.date?.[1]?.toDate(), "iso-string"),
                    "hours": parseFloat(editData?.hours) || 0,
                    "group_id": filterValues?.day_calendar_groups?.group_id,
                    "shift_start_time": dateConvert(editData?.shift_start, "iso-string") || "",
                    "shift_end_time": dateConvert(editData?.shift_end, "iso-string") || ""
                }
                const res = await services.getInvokeRemote("POST", Urls("UPSERTHOLIDAYCALENDERDAYHOURS"), payload);
                if (res) {
                    showSuccess("Success", res?.body?.message);
                    getHolidayCalender();
                    setEditData({ date: [], hours: "", shift_start: "", shift_end: "" });
                    setEdit(false);
                }
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    return useMemo(() => ({
        filterValues, setFilterValues, groupOption, dateTemplate,
        tagRef, getHolidayCalender, upsertHolidayCalender
        , gridRef, rowData, setRowData, loader, updateHolidayPopup, setUpdateHolidayPopup, dayTypeOption, setHolidayType,
        holidayType, visible, setVisible, handleDelete, handleChange, updatedData, handleSelctedDate, selectView, setSelectView, columnDefs, mappedData, edit, setEdit, editData, setEditData, handleUpsertCalendarHours, showCalendarConfig, setShowCalendarConfig, showGenerateCalendar, setShowGenerateCalendar
    }), [filterValues, setFilterValues, groupOption, dateTemplate, tagRef, getHolidayCalender,
        , gridRef, rowData, setRowData, loader, updateHolidayPopup, setUpdateHolidayPopup, upsertHolidayCalender
        , dayTypeOption, setHolidayType, holidayType, visible, setVisible, handleDelete, handleChange, updatedData, handleSelctedDate, selectView, setSelectView, columnDefs, mappedData, edit, setEdit, editData, setEditData, handleUpsertCalendarHours, showCalendarConfig, setShowCalendarConfig, showGenerateCalendar, setShowGenerateCalendar])
}